import React from 'react'

import { twMerge } from 'tailwind-merge'

interface ShinyProgressBarProps {
  progress: number
  className?: string
}

export const ShinyProgressBar: React.FC<ShinyProgressBarProps> = ({
  progress,
  className,
}) => {
  return (
    <div
      className={twMerge(
        'w-full bg-primary-200 dark:bg-primary-700 h-[5px] rounded-full',
        className,
      )}
    >
      <div
        style={
          {
            width: `${progress * 100}%`,
            '--shiny-duration': '2.3s',
          } as React.CSSProperties
        }
        className="relative h-full w-full overflow-hidden rounded-full bg-green-500 dark:bg-green-600 transition-all duration-300 ease-out origin-left"
      >
        <div className="animate-shiny-sweep absolute inset-0 bg-gradient-to-r from-transparent via-white/40 via-50% to-transparent" />
      </div>
    </div>
  )
}
